import type { RouteRecordRaw } from 'vue-router'
import PageDashboard from '@/views/app/dashboard/page-dashboard.vue'
import LayoutApp from '@/views/app/the-layout.vue'
import AuthRoutes from './modules/auth'
import ErrorRoutes from './modules/error'
import { PendingRoutes, ReceiverRoutes, SenderRoutes } from './modules/move-order'
import PasswordRoutes from './modules/password'
import ProductRoutes from './modules/product'
import PurchaseRoutes from './modules/purchase-draft'
import PurchaseReturnRoutes from './modules/purchase-return'
import StockAdjustmentRoutes from './modules/stock-adjustment'
import StockOpnameRoutes from './modules/stock-opname'
import SupplierRoutes from './modules/supplier'

const routes: RouteRecordRaw[] = [
  layoutApp('/dashboard', [
    {
      path: '/',
      name: 'dashboard',
      component: PageDashboard,
      meta: { title: 'Dashboard' },
    },
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/css',
      name: 'css',
      component: () => import('@/views/app/css/page-index.vue'),
      meta: { title: 'CSS' },
    },
  ]),
  layoutApp('/produk', ProductRoutes),
  layoutApp('/pembelian', PurchaseRoutes),
  layoutApp('/pengiriman', SenderRoutes),
  layoutApp('/penerimaan', ReceiverRoutes),
  layoutApp('/mutasi/pending', PendingRoutes),
  layoutApp('/retur-pembelian', PurchaseReturnRoutes),
  layoutApp('/stockopname', StockOpnameRoutes),
  layoutApp('/supplier', SupplierRoutes),
  layoutApp('/penyesuaian-stok', StockAdjustmentRoutes),
  layoutApp('/ubah-password', PasswordRoutes),
  layoutApp('/barcode-cetak', [
    {
      path: 'produk',
      name: 'print barcode product',
      component: () => import('@/views/app/product/print-barcode/page-list-product.vue'),
      meta: { title: 'Cetak Barcode' },
    },
    {
      path: 'pembelian',
      name: 'print barcode purchase',
      component: () => import('@/views/app/product/print-barcode/page-list-purchase.vue'),
      meta: { title: 'Cetak Barcode Dari Pembelian' },
    },
  ]),

  {
    path: '/cetak',
    component: () => import('@/views/print/the-layout.vue'),
    children: [
      {
        path: '/cetak-barcode',
        name: 'print barcode final',
        component: () => import('@/views/app/product/print-barcode/page-print.vue'),
        meta: { title: 'Cetak Barcode' },
      },
      {
        path: 'faktur/:id',
        name: 'purchase print',
        component: () => import('@/views/app/purchase-draft/print/page-print.vue'),
        meta: { title: 'Cetak Faktur Pembelian' },
      },
      {
        path: 'retur/:id',
        name: 'print purchase return',
        component: () => import('@/views/app/purchase-return/print/page-print.vue'),
        meta: { title: 'Cetak Faktur Retur Pembelian' },
      },
    ],
  },

  AuthRoutes,
  ErrorRoutes,
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: LayoutApp,
  }
}

export default routes
